import { AxiosPromise } from 'axios';
import request from '@/utils/request';

import type {
  LoginVo,
  LoginForm,
  CodeVo,
  LoginVerifyForm,
  SocialAuthUrlQuery,
  SocialCallBackVo,
  SocialSignUpQuery,
  SocialSignUpVo,
  SendSignCodeQuery,
  CodeSignQuery,
  OneTapQuery,
  VerifyGoogleTokenVo
} from './types.ts';
/**
 * 登录
 */
export const login = (data: LoginForm): AxiosPromise<LoginVo> => {
  return request({
    url: '/member/auth/signin',
    headers: {
      isEncrypt: true
    },
    method: 'post',
    data
  });
};

/**
 * 验证登录
 */
export const loginVerify = (data: LoginVerifyForm): AxiosPromise<LoginVo> => {
  return request({
    url: '/member/auth/verifySignIn',
    headers: {
      isEncrypt: true
    },
    method: 'post',
    data
  });
};
/**
 * 获取验证码
 */
export const verificationCode = (): AxiosPromise<CodeVo> => {
  return request({
    url: '/member/auth/code',
    method: 'get'
  });
};
/**
 * 获取第三方授权地址
 */
export const socialAuthUrl = (params: SocialAuthUrlQuery) => {
  return request({
    url: '/member/auth/socialAuthUrl',
    method: 'get',
    params
  });
};

/**
 * 获取第三方授权重定向后缓存信息
 */
export const getSocialCallBack = (params: { key: string }): AxiosPromise<SocialCallBackVo> => {
  return request({
    url: '/member/auth/getSocialCallBack',
    method: 'get',
    params
  });
};

/**
 * 第三方授权注册绑定邮箱
 */
export const socialSignUp = (data: SocialSignUpQuery): AxiosPromise<SocialSignUpVo> => {
  return request({
    url: '/member/auth/socialSignUp',
    method: 'post',
    data
  });
};

/**
 * 谷歌第三方登录
 */
export const googleOneTapLogin = (data: OneTapQuery): AxiosPromise<VerifyGoogleTokenVo> => {
  return request({
    url: '/member/auth/verifyGoogleToken',
    method: 'post',
    data
  });
};
/**
 * 刷新token
 */
export const refreshLoginToken = (data: { refreshToken?: string }): AxiosPromise<LoginVo> => {
  return request({
    url: '/member/auth/refreshToken',
    headers: {
      isEncrypt: true
    },
    method: 'post',
    data
  });
};

/**
 * 发送登录验证码
 */
export const sendSignCode = (data: SendSignCodeQuery) => {
  return request({
    url: '/member/auth/sendSignCode',
    headers: {
      isEncrypt: true
    },
    method: 'post',
    data
  });
};

/**
 * 验证码登录
 */
export const codeSign = (data: CodeSignQuery): AxiosPromise<LoginVo> => {
  return request({
    url: '/member/auth/codeSign',
    headers: {
      isEncrypt: true
    },
    method: 'post',
    data
  });
};
